import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';
import bp from 'Styles/breakpoints';

export const Text = styled.p`
  ${({ $textSize }) => fontBody($textSize)}
`;

export const Bold = styled.b`
  font-weight: 700;
`;

export const Italic = styled.i`
  font-style: italic;
`;

export const Link = styled.a`
  text-decoration: none;
  cursor: pointer;
`;

export const Heading1 = styled.h1`
  ${fontTitle(24)}

  ${bp('large')} {
    ${fontTitle(32)}
  }
`;

export const Heading2 = styled.h2`
  ${fontTitle(24)}

  ${bp('large')} {
    ${fontTitle(32)}
  }
`;

export const List = styled.ul`
  li {
    display: flex;
  }

  /* Renders a check icon for the list item bullet */
  li:before {
    font-family: BeeIcon !important; /* stylelint-disable-line */
    content: '\\F015';
    display: flex;
    align-items: center;
    margin-right: 8px;
  }
`;
